import { useEffect } from 'react';
import { useRealtime } from './use-realtime';
import type { RealtimeEventHandler } from '../../types/realtime.types';

/**
 * Registers a realtime event listener for the component lifecycle.
 *
 * @param handler - Callback invoked for each realtime event message.
 */
export const useRealtimeEventListener = (
  handler: RealtimeEventHandler
): void => {
  const { addEventListener } = useRealtime();

  useEffect(() => addEventListener(handler), [addEventListener, handler]);
};
